import React, { useEffect } from "react";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import {
  setSelectedREportStatus,
  setSelectedREportStatusFilter,
} from "../../reducers/tradeSlice";
import { gettingCurrencyNumberWithOutSymbol } from "../../helpers/get-currency-number";
import {
  setCalenderDate,
  setCashOutSearch,
} from "../../reducers/reports_slice";
import { TRootState } from "../../store";
import TableView from "../../components/table_new";

const CashOutStandingReport = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setSelectedREportStatusFilter([]));
    dispatch(setCashOutSearch(""));
    dispatch(setSelectedREportStatus([]));
  }, []);

  const {
    cashOutStandingReportFilter,
    isLoading,
  } = useSelector((state: TRootState) => ({
    cashOutStandingReportFilter: state.reports.cashOutStandingReportFilter,
    isLoading: state.reports.isLoading,
  }));

  useEffect(() => {
    const today = moment().format("YYYY-MM-DD");

    dispatch(
      setCalenderDate({
        fromDate: today,
        toDate: today,
        mode: "DAILY",
      })
    );
  }, []);

  return (
    <>
      <div className="card_space_18">

        <TableView
          height="calc(100vh - 14rem)"
          loading={isLoading}
          columns={[
            { key: "sNo", header: "#", className: "text-center sticky left-0 min-w-[50px]" },
            { key: "loanId", header: "Loan Id", className: "sticky left-[50px] min-w-[150px]" },
            { key: "loanAccNo", header: "Customer Id", className: "min-w-[150px]" },
            { key: "customerName", header: "Customer Name", className: "min-w-[200px]" },
            { key: "marketName", header: "Market Name", className: "min-w-[250px]" },
            { key: "location", header: "Location", className: "min-w-[200px]" },
            { key: "rmName", header: "RM Name", className: "min-w-[180px]" },
            { key: "loanProduct", header: "Loan Product", className: "min-w-[150px]" },
            { key: "finPartner", header: "Finance Partner", className: "min-w-[180px]" },
            { key: "disbAmt", header: "Disbursement Amount (₹)", type: "NUMBER", className: "min-w-[200px]" },
            { key: "disbDate", header: "Disbursement Date", className: "min-w-[150px]" },
            { key: "tenure", header: "Tenure (Days)", className: "min-w-[150px]" },
            { key: "adjPrincipal", header: "Principal Paid (₹)", type: "NUMBER", className: "min-w-[150px]" },
            { key: "adjInterest", header: "Interest Paid (₹)", type: "NUMBER", className: "min-w-[150px]" },
            { key: "adjDc", header: "Delay Charges Paid (₹)", type: "NUMBER", className: "min-w-[180px]" },
            { key: "principalOutstanding", header: "Principal Outstanding (₹)", type: "NUMBER", className: "min-w-[200px]" },
            { key: "interestOutstanding", header: "Interest Outstanding (₹)", type: "NUMBER", className: "min-w-[200px]" },
            { key: "outstanding", header: "Loan Outstanding (₹)", type: "NUMBER", className: "min-w-[180px]" },
            { key: "overdue", header: "OverDue Amount (₹)", type: "NUMBER", className: "min-w-[180px]" },
            { key: "dpd", header: "DPD", className: "min-w-[150px]" },
          ]}
          data={cashOutStandingReportFilter?.map((item, i) => {
            return {
              sNo: i + 1,
              loanId: item.loanId,

              loanAccNo: item.loanAccNo,
              customerName: item.customerName,
              marketName: item.marketName,
              location: item.location,
              rmName: item.rmName,
              loanProduct: item.loanProduct,
              finPartner: item.finPartner || "-",

              disbAmt: gettingCurrencyNumberWithOutSymbol(item.disbAmt, true),
              disbDate: item.disbDate
                ? moment(item.disbDate).format("DD-MMM-YYYY")
                : "-",
              tenure: item.tenure,

              adjPrincipal: gettingCurrencyNumberWithOutSymbol(item.adjPrincipal, true),
              adjInterest: gettingCurrencyNumberWithOutSymbol(item.adjInterest, true),
              adjDc: gettingCurrencyNumberWithOutSymbol(item.adjDc, true),

              principalOutstanding: gettingCurrencyNumberWithOutSymbol(item.principalOutstanding, true),
              interestOutstanding: gettingCurrencyNumberWithOutSymbol(item.interestOutstanding, true),
              outstanding: gettingCurrencyNumberWithOutSymbol(item.outstanding, true),
              overdue: gettingCurrencyNumberWithOutSymbol(item.overdue, true),

              dpd: item.dpd,
            };
          })}
        // rowClickAction="expand"
        // isRowExpandable={(row) => true}
        // renderExpandedRow={(row) => <span>hii</span> }
        />

      </div>
    </>
  );
};

export default CashOutStandingReport;
